
module.exports = {
  'en-US': { ...require("./en/en-US.json"), ...require("./en/jsApiAuth_en.json") },
  'zh-CN': { ...require('./zh/zh-CN.json'), ...require("./zh/jsApiAuth_zh.json") },
};
